import React from 'react'
import { Card, CardBody } from 'reactstrap';
import { FaArrowTrendUp, FaArrowDown } from "react-icons/fa6";
import { SiOpenai } from "react-icons/si";
import Loader3 from '../../../../../../CommonElements/Spinner/loader3';
import { ArrowDown } from 'react-feather';
import { PiWarningOctagon } from 'react-icons/pi';
import { IoWarning } from 'react-icons/io5';

const AcceptedRecords = ({ data, loader, totalRecords }) => {
    let accuracyPercent = data
    return (
        <Card style={{ borderRadius: '24px', minHeight: '170px', maxHeight: 'auto' }}>
            {loader ? <span className="w-100 h-100 d-flex justify-content-center align-items-center position-absolute"><Loader3 /></span> :
                <CardBody className='p-4'>
                    <p style={{ fontSize: '16px', color: '#383838', fontWeight: '400' }} className="ellipsis-text">Verified Safety Violations</p>
                    <div className=' d-flex align-items-center gap-2 '>
                        {/* <SiOpenai style={{ width: '40px', height: '40px', borderRadius: '20px', padding: '5px', background: '#175FA4', color: 'white' }} /> */}
                        <IoWarning style={{width:'40px',height:'40px',borderRadius:'50%',padding:'8px',background:'#175FA4',color:'white'}}/>
                        {JSON.parse(localStorage.getItem('userData'))?.factory?.id === 32 ? <p className=' m-0' style={{ color: '#595959', fontSize: '16px', fontSize: '30px', fontWeight: '500' }} >
                            {data || 'N/A'}
                        </p> :
                         <p className=' m-0' style={{ color: '#595959', fontSize: '16px', fontSize: '30px', fontWeight: '500' }} >
                            {!totalRecords ? 'N/A' : `${data || 'N/A'}/${totalRecords || '0'}`}
                        </p>
                        }
                       
                    </div>
                </CardBody>
            }
        </Card>
    )
}
export default AcceptedRecords

// import React from 'react'
// import { Card, CardBody } from 'reactstrap';
// import { FaArrowTrendUp, FaArrowDown } from "react-icons/fa6";
// import { SiOpenai } from "react-icons/si";
// import Loader3 from '../../../../../../CommonElements/Spinner/loader3';
// import { ArrowDown } from 'react-feather';
// import { PiWarningOctagon } from 'react-icons/pi';
// import { IoWarning } from 'react-icons/io5';

// const AcceptedRecords = ({ data, loader, totalRecords, acknowledgedCount, nonAcknowledgedCount }) => {
//     let accuracyPercent = data
//     return (
//         <Card 
//             style={{ 
//                 borderRadius: '24px', 
//                 minHeight: '180px', 
//                 maxHeight: 'auto',
//                 background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
//                 border: 'none',
//                 boxShadow: '0 20px 40px rgba(102, 126, 234, 0.15), 0 8px 16px rgba(102, 126, 234, 0.1)',
//                 position: 'relative',
//                 overflow: 'hidden',
//                 transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)'
//             }}
//             className="alert-card-hover"
//         >
//             {/* Decorative background elements */}
//             <div style={{
//                 position: 'absolute',
//                 top: '-50px',
//                 right: '-50px',
//                 width: '120px',
//                 height: '120px',
//                 background: 'rgba(255, 255, 255, 0.1)',
//                 borderRadius: '50%',
//                 backdropFilter: 'blur(10px)'
//             }} />
//             <div style={{
//                 position: 'absolute',
//                 bottom: '-30px',
//                 left: '-30px',
//                 width: '80px',
//                 height: '80px',
//                 background: 'rgba(255, 255, 255, 0.08)',
//                 borderRadius: '50%',
//                 backdropFilter: 'blur(5px)'
//             }} />
            
//             {loader ? 
//                 <span className="w-100 h-100 d-flex justify-content-center align-items-center position-absolute">
//                     <Loader3 />
//                 </span> :
//                 <CardBody className='px-4 py-4' style={{ position: 'relative', zIndex: 2 }}>
//                     {/* Header */}
//                     <div className="d-flex align-items-center justify-content-between mb-3">
//                         <p style={{ 
//                             fontSize: '14px', 
//                             color: 'rgba(255, 255, 255, 0.9)', 
//                             fontWeight: '500',
//                             letterSpacing: '0.5px',
//                             textTransform: 'uppercase'
//                         }} className="mb-0">
//                             Alert Management
//                         </p>
//                         <div className="d-flex align-items-center gap-2">
//                             <div style={{
//                                 width: '6px',
//                                 height: '6px',
//                                 background: '#10b981',
//                                 borderRadius: '50%',
//                                 boxShadow: '0 0 8px rgba(16, 185, 129, 0.6)'
//                             }} />
//                             <div style={{
//                                 width: '6px',
//                                 height: '6px',
//                                 background: '#ef4444',
//                                 borderRadius: '50%',
//                                 boxShadow: '0 0 8px rgba(239, 68, 68, 0.6)'
//                             }} />
//                         </div>
//                     </div>
                    
//                     {/* Total Count */}
//                     <div className="d-flex align-items-center gap-3 mb-4">
//                         <div style={{
//                             width: '56px',
//                             height: '56px',
//                             borderRadius: '16px',
//                             background: 'rgba(255, 255, 255, 0.15)',
//                             backdropFilter: 'blur(10px)',
//                             display: 'flex',
//                             alignItems: 'center',
//                             justifyContent: 'center',
//                             border: '1px solid rgba(255, 255, 255, 0.2)'
//                         }}>
//                             <IoWarning style={{ 
//                                 width: '28px', 
//                                 height: '28px', 
//                                 color: '#fbbf24'
//                             }} />
//                         </div>
                        
//                         <div>
//                             <p style={{ 
//                                 color: 'white', 
//                                 fontSize: '36px', 
//                                 fontWeight: '700',
//                                 margin: '0',
//                                 lineHeight: '1',
//                                 textShadow: '0 2px 4px rgba(0, 0, 0, 0.1)'
//                             }}>
//                                 {totalRecords || '0'}
//                             </p>
//                             <p style={{
//                                 color: 'rgba(255, 255, 255, 0.8)',
//                                 fontSize: '12px',
//                                 margin: '4px 0 0 0',
//                                 fontWeight: '400'
//                             }}>
//                                 Total Alerts
//                             </p>
//                         </div>
//                     </div>
                    
//                     {/* Alert Breakdown */}
//                     <div className="row g-2">
//                         {/* Acknowledged Alerts */}
//                         <div className="col-6">
//                             <div style={{
//                                 background: 'rgba(16, 185, 129, 0.15)',
//                                 borderRadius: '12px',
//                                 padding: '12px',
//                                 backdropFilter: 'blur(5px)',
//                                 border: '1px solid rgba(16, 185, 129, 0.2)'
//                             }}>
//                                 <div className="d-flex align-items-center gap-2 mb-1">
//                                     <div style={{
//                                         width: '8px',
//                                         height: '8px',
//                                         background: '#10b981',
//                                         borderRadius: '50%',
//                                         boxShadow: '0 0 8px rgba(16, 185, 129, 0.4)'
//                                     }} />
//                                     <span style={{
//                                         color: '#10b981',
//                                         fontSize: '11px',
//                                         fontWeight: '600',
//                                         textTransform: 'uppercase',
//                                         letterSpacing: '0.5px'
//                                     }}>
//                                         Acknowledged
//                                     </span>
//                                 </div>
//                                 <p style={{
//                                     color: 'white',
//                                     fontSize: '24px',
//                                     fontWeight: '700',
//                                     margin: '0',
//                                     lineHeight: '1'
//                                 }}>
//                                     {acknowledgedCount || '0'}
//                                 </p>
//                             </div>
//                         </div>
                        
//                         {/* Non-Acknowledged Alerts */}
//                         <div className="col-6">
//                             <div style={{
//                                 background: 'rgba(239, 68, 68, 0.15)',
//                                 borderRadius: '12px',
//                                 padding: '12px',
//                                 backdropFilter: 'blur(5px)',
//                                 border: '1px solid rgba(239, 68, 68, 0.2)'
//                             }}>
//                                 <div className="d-flex align-items-center gap-2 mb-1">
//                                     <div style={{
//                                         width: '8px',
//                                         height: '8px',
//                                         background: '#ef4444',
//                                         borderRadius: '50%',
//                                         boxShadow: '0 0 8px rgba(239, 68, 68, 0.4)',
//                                         animation: nonAcknowledgedCount > 0 ? 'pulse 2s infinite' : 'none'
//                                     }} />
//                                     <span style={{
//                                         color: '#ef4444',
//                                         fontSize: '11px',
//                                         fontWeight: '600',
//                                         textTransform: 'uppercase',
//                                         letterSpacing: '0.5px'
//                                     }}>
//                                         Pending
//                                     </span>
//                                 </div>
//                                 <p style={{
//                                     color: 'white',
//                                     fontSize: '24px',
//                                     fontWeight: '700',
//                                     margin: '0',
//                                     lineHeight: '1'
//                                 }}>
//                                     {nonAcknowledgedCount || '0'}
//                                 </p>
//                             </div>
//                         </div>
//                     </div>
//                 </CardBody>
//             }
            
//             <style jsx>{`
//                 .alert-card-hover:hover {
//                     transform: translateY(-4px);
//                     box-shadow: 0 32px 64px rgba(102, 126, 234, 0.25), 0 16px 32px rgba(102, 126, 234, 0.15) !important;
//                 }
                
//                 @keyframes pulse {
//                     0%, 100% {
//                         opacity: 1;
//                         transform: scale(1);
//                     }
//                     50% {
//                         opacity: 0.7;
//                         transform: scale(1.1);
//                     }
//                 }
//             `}</style>
//         </Card>
//     )
// }

// export default AcceptedRecords













// import React from 'react'
// import { Card, CardBody } from 'reactstrap';
// import { FaArrowTrendUp, FaArrowDown } from "react-icons/fa6";
// import { SiOpenai } from "react-icons/si";
// import Loader3 from '../../../../../../CommonElements/Spinner/loader3';
// import { ArrowDown } from 'react-feather';
// import { PiWarningOctagon } from 'react-icons/pi';
// import { IoWarning } from 'react-icons/io5';

// const AcceptedRecords = ({ data, loader, totalRecords, acknowledgedCount, nonAcknowledgedCount }) => {
//     let accuracyPercent = data
//     return (
//         <Card 
//             style={{ 
//                 borderRadius: '24px', 
//                 minHeight: '170px', 
//                 maxHeight: '170px',
//                 background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
//                 border: 'none',
//                 boxShadow: '0 20px 40px rgba(102, 126, 234, 0.15), 0 8px 16px rgba(102, 126, 234, 0.1)',
//                 position: 'relative',
//                 overflow: 'hidden',
//                 transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)'
//             }}
//             className="alert-card-hover"
//         >
//             {/* Decorative background elements */}
//             <div style={{
//                 position: 'absolute',
//                 top: '-50px',
//                 right: '-50px',
//                 width: '120px',
//                 height: '120px',
//                 background: 'rgba(255, 255, 255, 0.1)',
//                 borderRadius: '50%',
//                 backdropFilter: 'blur(10px)'
//             }} />
//             <div style={{
//                 position: 'absolute',
//                 bottom: '-30px',
//                 left: '-30px',
//                 width: '80px',
//                 height: '80px',
//                 background: 'rgba(255, 255, 255, 0.08)',
//                 borderRadius: '50%',
//                 backdropFilter: 'blur(5px)'
//             }} />
            
//             {loader ? 
//                 <span className="w-100 h-100 d-flex justify-content-center align-items-center position-absolute">
//                     <Loader3 />
//                 </span> :
//                 <CardBody className='px-4 py-2' style={{ position: 'relative', zIndex: 2 }}>
//                     {/* Header */}
                 
                    
//                     {/* Total Count */}
//                     <div className="d-flex align-items-center gap-3 mb-4">
//                         <div style={{
//                             width: '56px',
//                             height: '56px',
//                             borderRadius: '16px',
//                             background: 'rgba(255, 255, 255, 0.15)',
//                             backdropFilter: 'blur(10px)',
//                             display: 'flex',
//                             alignItems: 'center',
//                             justifyContent: 'center',
//                             border: '1px solid rgba(255, 255, 255, 0.2)'
//                         }}>
//                             <IoWarning style={{ 
//                                 width: '28px', 
//                                 height: '28px', 
//                                 color: '#fbbf24'
//                             }} />
//                         </div>
                        
//                         <div>
//                             <p style={{ 
//                                 color: 'white', 
//                                 fontSize: '36px', 
//                                 fontWeight: '700',
//                                 margin: '0',
//                                 lineHeight: '1',
//                                 textShadow: '0 2px 4px rgba(0, 0, 0, 0.1)'
//                             }}>
//                                 {totalRecords || '0'}
//                             </p>
//                             <p style={{
//                                 color: 'rgba(255, 255, 255, 0.8)',
//                                 fontSize: '12px',
//                                 margin: '4px 0 0 0',
//                                 fontWeight: '400'
//                             }}>
//                                 Total Alerts
//                             </p>
//                         </div>
//                     </div>
                    
//                     {/* Alert Breakdown */}
//                     <div className="row g-2">
//                         {/* Acknowledged Alerts */}
//                         <div className="col-6">
//                             <div style={{
//                                 background: 'rgba(16, 185, 129, 0.15)',
//                                 borderRadius: '12px',
//                                 padding: '12px',
//                                 backdropFilter: 'blur(5px)',
//                                 border: '1px solid rgba(16, 185, 129, 0.2)'
//                             }}>
//                                 <div className="d-flex align-items-center gap-2 mb-1">
//                                     <div style={{
//                                         width: '8px',
//                                         height: '8px',
//                                         background: '#10b981',
//                                         borderRadius: '50%',
//                                         boxShadow: '0 0 8px rgba(16, 185, 129, 0.4)'
//                                     }} />
//                                     <span style={{
//                                         color: '#10b981',
//                                         fontSize: '11px',
//                                         fontWeight: '600',
//                                         textTransform: 'uppercase',
//                                         letterSpacing: '0.5px'
//                                     }}>
//                                         Acknowledged
//                                     </span>
//                                 </div>
//                                 <p style={{
//                                     color: 'white',
//                                     fontSize: '24px',
//                                     fontWeight: '700',
//                                     margin: '0',
//                                     lineHeight: '1'
//                                 }}>
//                                     {acknowledgedCount || '0'}
//                                 </p>
//                             </div>
//                         </div>
                        
//                         {/* Non-Acknowledged Alerts */}
//                         <div className="col-6">
//                             <div style={{
//                                 background: 'rgba(239, 68, 68, 0.15)',
//                                 borderRadius: '12px',
//                                 padding: '12px',
//                                 backdropFilter: 'blur(5px)',
//                                 border: '1px solid rgba(239, 68, 68, 0.2)'
//                             }}>
//                                 <div className="d-flex align-items-center gap-2 mb-1">
//                                     <div style={{
//                                         width: '8px',
//                                         height: '8px',
//                                         background: '#ef4444',
//                                         borderRadius: '50%',
//                                         boxShadow: '0 0 8px rgba(239, 68, 68, 0.4)',
//                                         animation: nonAcknowledgedCount > 0 ? 'pulse 2s infinite' : 'none'
//                                     }} />
//                                     <span style={{
//                                         color: '#ef4444',
//                                         fontSize: '11px',
//                                         fontWeight: '600',
//                                         textTransform: 'uppercase',
//                                         letterSpacing: '0.5px'
//                                     }}>
//                                         Pending
//                                     </span>
//                                 </div>
//                                 <p style={{
//                                     color: 'white',
//                                     fontSize: '24px',
//                                     fontWeight: '700',
//                                     margin: '0',
//                                     lineHeight: '1'
//                                 }}>
//                                     {nonAcknowledgedCount || '0'}
//                                 </p>
//                             </div>
//                         </div>
//                     </div>
//                 </CardBody>
//             }
            
//             <style jsx>{`
//                 .alert-card-hover:hover {
//                     transform: translateY(-4px);
//                     box-shadow: 0 32px 64px rgba(102, 126, 234, 0.25), 0 16px 32px rgba(102, 126, 234, 0.15) !important;
//                 }
                
//                 @keyframes pulse {
//                     0%, 100% {
//                         opacity: 1;
//                         transform: scale(1);
//                     }
//                     50% {
//                         opacity: 0.7;
//                         transform: scale(1.1);
//                     }
//                 }
//             `}</style>
//         </Card>
//     )
// }

// export default AcceptedRecords
























